import React from 'react'
import AssignFacility from '../../features/apartment/AssignFacility'

const AssignFacilityPage = () => {
    return (
        <AssignFacility />
    )
}

export default AssignFacilityPage